export const ADMIN = 'admin'
